module.exports = __webpack_public_path__ + "img/noimage.5307939b.png";